export const LdContextKind = {
    Multi: 'multi',
    Device: 'device',
    User: 'user',
} as const;
export type LDContextKind = typeof LdContextKind[keyof typeof LdContextKind];
